module.exports = __webpack_public_path__ + "static/media/dribbble.686dc64d.svg";